<template>
    <div class="select-mcmp">
        <div @click="toggleDropdown()" class="box">
            <span class="value">{{ selectedText }}</span>
            <v-icon v-if="!expanded" class="icon" icon>fa-caret-down</v-icon>
            <v-icon v-else class="icon" icon>fa-caret-up</v-icon>
        </div>
        <ul :class="'options ' + (expanded ? 'expanded' : '')">
            <li class="first-option option">{{ label }}</li>
            <li v-if="allOption" @click="updateValue" class="option" :data-value="allOpt">{{ $t("all") }}</li>
            <li class="option" @click="updateValue" v-for="(option, index) in options" :key="index"
                :data-value="option.value ? option.value : option">{{
                    option.text ? option.text : option }}
            </li>
        </ul>
    </div>
</template>

<script>
import { SELECT_SINGLE } from "./constants"

export default {
    name: "SwisetSelect",
    props: {
        label: {
            type: String,
            required: true
        },
        options: {
            type: Array,
            required: true
        },
        type: {
            type: Number,
            required: true
        },
        allOption: {
            type: Boolean,
            required: false
        },
        placeholder: {
            type: String,
        },
        changeEvent: {
            type: Function
        }

    },
    data() {
        return {
            selectedValue: undefined,
            selectedText: this.placeholder,
            expanded: false,
            allOpt: this.$i18n.messages[this.$i18n.locale].all
        }
    },
    computed: {
        isSelected(e) {
            if (e.target) {
                return true;
            }
            return false;
        }
    },
    mounted() {

    },
    methods: {
        updateValue(e) {
            switch (this.type) {
                case SELECT_SINGLE:
                    this.selectedValue = e.target.textContent !== this.allOpt ? e.target.getAttribute("data-value") : undefined;
                    this.selectedText = this.selectedValue ? e.target.textContent : this.allOpt;
                    break;
                default:
                    var val = e.target.getAttribute("data-value");
                    if (!this.selectedValue) {
                        this.selectedValue = [];
                        e.target.parentNode.querySelectorAll(".option").forEach((el, index) => {
                            if (index > 1)
                                el.classList.remove("selected");
                        });
                    }

                    if (val !== this.allOpt) {
                        e.target.classList.add("selected");
                        if (!this.selectedValue.includes(val)) {
                            this.selectedValue.push(val);
                            this.selectedText = this.selectedValue.toString()
                            if (this.selectedValue.length > 3) {
                                this.selectedText = `${this.selectedValue[0]} +${this.selectedValue.length - 1}`;
                            }
                        }
                        else {
                            e.target.classList.remove("selected");
                            this.selectedValue.splice(this.selectedValue.indexOf(val), 1);
                            this.selectedText = this.selectedValue.toString()
                            if (this.selectedValue.length > 3) {
                                this.selectedText = `${this.selectedValue[0]}, +${this.selectedValue.length - 1}`;
                            }
                            if (!this.selectedValue.length) {
                                e.target.parentNode.querySelectorAll(".option").forEach((el, index) => {
                                    if (index > 1)
                                        el.classList.add("selected");
                                });
                            }
                        }
                    } else {
                        this.selectedValue = []
                        e.target.parentNode.querySelectorAll(".option").forEach((el, index) => {
                            if (index > 1)
                                el.classList.add("selected");
                        });
                    }
                    if (this.selectedValue.length == 0) {
                        this.selectedValue = undefined;
                        this.selectedText = this.placeholder
                    }
                    break;
            }
            this.toggleDropdown();
            this.$emit('input', this.selectedValue);
            if(this.changeEvent)
                this.changeEvent();
        },
        toggleDropdown() {
            this.expanded = !this.expanded;
        },
    }
}
</script>
<i18n>
    {
        "es":{
            "all":"Todo"
        },
        "en":{
            "all":"All"
        }
    }
</i18n>
<style lang="scss">
.select-mcmp {
    flex-grow: 1;
    margin-right: 10px;
    position: relative;

    .box {
        position: relative;
        padding: 8px 14px;
        background-color: var(--v-alternativeBtnBackground-base);
        font-family: 'Avenir', sans-serif;
        border-radius: 14px;
        border: 1px solid transparent;
        transition: border 0.25s linear;
        max-width: 350px;


        .icon {
            color: var(--v-mainBlack-base) !important;
            position: absolute;
            right: 15px;
            top: 5%;
        }

        .value {
            display: block;
            color: inherit;
            font-style: normal;
            text-wrap: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            max-width: 90%;
        }

        &:hover {
            cursor: pointer;
            color: var(--v-mainBtnBackground-base) !important;
            transition: all 0.05s linear;

        }

    }

    .options {
        display: none;
        width: 100%;
        max-height: 0;
        position: absolute;
        background-color: var(--v-alternativeBtnBackground-base);
        overflow: auto;
        list-style-type: none;
        transition: max-height 0.15s ease-out;
        padding: 0;
        border-radius: 14px;
        margin-top: 5px;
        z-index: 5;

        .option {
            line-height: 1.2;
            position: relative;
            padding: 10px 0;
            margin: 0 14px;
            background-color: var(--v-alternativeBtnBackground-base);
            color: var(--v-mainBlack-base);
            font-family: 'Avenir', sans-serif;
            border-bottom: 1px solid var(--v-mainBlack-base);
            font-size: 14px;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;

            &:hover {
                text-decoration: none;
                color: var(--v-mainBtnBackground-base) !important;
                cursor: pointer;
            }

            &.first-option {
                font-size: 12px;
                padding: 5px 0;
                font-style: normal;
                border: 0;

                &:hover {
                    cursor: default;
                    opacity: 1;
                }
            }

            &.selected {
                color: var(--v-mainBtnBackground-base);

                &::before {
                    content: '\2713';
                    display: inline-block;
                    background-color: var(--v-darkGreen-base);
                    color: var(--v-mainWhite-base);
                    padding: 3px 6px 3px 6px;
                    border-radius: 20px;
                    margin-right: 3px;
                }
            }
        }

        &.expanded {
            display: block;
            max-height: 500px;
            transition: max-height 0.25s ease-in;
        }

    }
}
</style>